import React, { Component } from 'react'
import { computed, action } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import Tooltip from 'material-ui/Tooltip'
import Datepicker from 'shared/components/Datepicker'
import { ChevronDoubleUp, FileTree } from 'mdi-material-ui'
import { SCROLL_ROOT_ID } from 'components/App'
import Direction from 'components/Direction'
import ClearanceCountry from 'components/ClearanceCountry'
import OriginCountry from 'components/OriginCountry'
import withAppStore from 'decorators/withAppStore'
import { DIRECTION_CUSTOMS } from '../stores/QueryParamsStore'
import styles from 'styles/components/TopBar'

@withStyles(styles)
@withAppStore
@observer
export default class TopBar extends Component {
  constructor(params) {
    super(params)
    this.breakpoint = 700
    this.state = {
      isMobile: window.innerWidth <= this.breakpoint,
    }
  }

  @computed
  get showCollapseAll() {
    return !this.appStore.allCollapsed
  }

  @computed
  get isTreeLinkEnabled() {
    return this.appStore.treeLink !== null
  }

  render() {
    const { title, classes } = this.props
    const { showTitle, direction, clearanceCountry, originCountry } = this.appStore

    return (
      <div>
        {showTitle && (
          <AppBar color="default" position="fixed" elevation={1}>
            <Toolbar>
              {false && (
                <Tooltip title="Перейти к дереву" placement="bottom">
                  <IconButton onClick={() => this.handleTreeLinkClick()}>
                    <FileTree />
                  </IconButton>
                </Tooltip>
              )}

              {!this.state.isMobile && <Typography variant="headline" className={classes.flex}>
                {title}
              </Typography>
              }
              {this.state.isMobile && <Typography variant="caption" className={classes.flex}>
                {title}
              </Typography>
              }
              <Direction direction={direction} isMobile={this.state.isMobile} />
              <ClearanceCountry
                clearanceCountry={clearanceCountry}
                isMobile={this.state.isMobile}
              />
              {direction !== DIRECTION_CUSTOMS.EXPORT &&  <OriginCountry
                originCountry={originCountry}
                isMobile={this.state.isMobile}
              />}

              <Datepicker isMobile={this.state.isMobile}/>

              {this.showCollapseAll && (
                <Tooltip title="Свернуть все" placement="bottom">
                  <IconButton onClick={this.handleCollapseAll}>
                    <ChevronDoubleUp />
                  </IconButton>
                </Tooltip>
              )}
            </Toolbar>
          </AppBar>
        )}
      </div>
    )
  }

  @action.bound
  handleCollapseAll() {
    this.appStore.allCollapsed = true
    document.getElementById(SCROLL_ROOT_ID).scrollTop = 0
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResizeWindow.bind(this))
    this.handleResizeWindow()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResizeWindow)
  }

  handleResizeWindow = () => {
    this.setState({
      isMobile: window.innerWidth <= this.breakpoint,
    })
  }


  @action.bound
  handleTreeLinkClick() {
    const { codes } = this.appStore.dataStore
    var tnved = null
    if (codes.length) {
      tnved = codes.items[0]
    }

    var calendar_date = this.appStore.onDate
    var date = calendar_date ? calendar_date.format('DD-MM-YYYY') : null

    var originSelfHref = `${this.appStore.treeLink}#`
    if (tnved === null || tnved.id === 0) {
      originSelfHref += `/date=${date}&search-open=false`
    } else {
      originSelfHref += `expanded=${tnved.id}`
    }

    window.open(originSelfHref, this.appStore.treeLinkTarget)
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar.js